import { t } from 'i18next';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { contactGroupService } from 'contacts/services';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider } from 'core/states';
import { useProjectCustomerActions } from 'pricing/hooks';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  pricingProfileId: number;
  projectId: number;
}

interface IAddProjectCustomerForm {
  customer: { id: number; title: string } | null;
}

const schema = () =>
  yup.object({
    customer: yup.object().label(t('labelCustomer')).nullable().required(),
  });

export const AddProjectCustomer = ({ isOpen, onClose, pricingProfileId, projectId }: IProps) => {
  const { t } = useTranslation();

  const { addProjectCustomer } = useProjectCustomerActions();

  const defaultValues: IAddProjectCustomerForm = {
    customer: null,
  };

  const onSubmit =
    (reset: UseFormReset<IAddProjectCustomerForm>) => async (data: IAddProjectCustomerForm) => {
      if (!data.customer) {
        return;
      }

      const { success } = await addProjectCustomer({
        allAddresses: 1,
        contactGroup: data.customer.id,
        pricingProfile: pricingProfileId,
        project: projectId,
      });

      if (!success) {
        return;
      }

      setTimeout(() => {
        handleClose(reset);
      }, 1000);
    };

  const handleClose = (reset?: UseFormReset<IAddProjectCustomerForm>) => {
    reset?.(defaultValues);
    onClose();
  };

  return (
    <FormProvider schema={schema()} defaultValues={defaultValues} resetDefaultValues>
      <Form
        isOpen={isOpen}
        onClose={handleClose}
        title={t('titleAddCustomer')}
        onSubmit={onSubmit}
        submitBtnLabel={t('buttonLabelAdd')}
      >
        <FormField
          name="customer"
          type={InputType.AUTOCOMPLETE}
          wrapperStyle={{ flex: 1 }}
          inputProps={{
            placeholder: t('placeholderSelectCustomer'),
            getOptions: contactGroupService.getManyAutocomplete,
            requestPayload: {
              filters: { projectCustomer: projectId },
            },
            disableClearable: true,
          }}
        />
      </Form>
    </FormProvider>
  );
};
